/* eslint-disable import/extensions */
/* eslint-disable react/no-array-index-key */
import React from 'react'
import { shape, string } from 'prop-types'
import LinkPromotionsContainer from 'components/link-promotions/LinkPromotion'
import 'components/link-promotions/link-promotion.scss'

const LinkPromotions = ({
  moduleData: { Links }, name, type, moduleId,
}) => {
  const promoLinks = Links.map((content, index) => {
    const {
      iconClass, linkText, image: { clickThrough: { value: imageUrl } },
      trackingCode, link: { clickThrough: { value } },
    } = content
    const linkPath = { path: value }
    return (<LinkPromotionsContainer
      link={linkPath}
      iconClass={iconClass}
      linkText={linkText}
      customImage={imageUrl}
      trackingCode={trackingCode}
      key={index}
    />)
  })
  return (
    <div
      className="wrapper promo-links"
      data-module={name}
      data-module-name={name}
      data-module-id={moduleId}
      data-module-type={type}
    >{promoLinks}
    </div>
  )
}

LinkPromotions.propTypes = {
  moduleData: shape({}).isRequired,
  name: string,
  moduleId: string,
  type: string,
}

LinkPromotions.defaultProps = {
  name: null,
  moduleId: null,
  type: null,
}

export default LinkPromotions



// WEBPACK FOOTER //
// ./components/cms/components/link-promotions.js